/**
 * Row-level self-identification helper for public pages.
 *
 * A row belongs to the viewer when the row's `profileUserId` matches the
 * currently-logged-in user's Supabase id. Anonymous viewers never match.
 */

export function viewerHighlight(
  profileUserId: string | null | undefined,
  viewerUserId: string | null | undefined,
  options: { bold?: boolean } = {},
): { isMine: boolean; className: string } {
  const isMine =
    !!viewerUserId && !!profileUserId && profileUserId === viewerUserId;
  if (!isMine) return { isMine: false, className: '' };
  const className =
    options.bold === false ? 'bg-primary/10' : 'bg-primary/10 font-semibold';
  return { isMine: true, className };
}
